import { render, staticRenderFns } from "./KdsPosProfile.vue?vue&type=template&id=87049fbc&"
import script from "./KdsPosProfile.vue?vue&type=script&lang=js&"
export * from "./KdsPosProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports